import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Button, Form, Spinner } from 'react-bootstrap';
import TestimonialsModal from './TestimonialsModal';
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";

import swal from 'sweetalert';
import axios from 'axios';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { Switch } from '@mui/material';
import { toast } from 'react-toastify';


const VirtualDevice = () => {
    const [isAllowed, setIsAllowed] = useState(false);
    const [loadStatus,setLoadStatus] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.get(`${BACKEND_SERVER_URL}/app/allowVirtualDevice`);
                setIsAllowed(response.data.isAllow);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, [loadStatus]);

    const handleToggle = async (event) => {
        try {
            const response=await axios.get(`${BACKEND_SERVER_URL}/app/toggleVirtualDeviceStatus`);
            console.log(response.data);
            setIsAllowed(!isAllowed);
            setLoadStatus(!loadStatus);
        } catch (error) {
            toast.error('Error toggling virtual device status');
            console.error('Error toggling virtual device status:', error);
        }
 


    }



    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <Switch checked={isAllowed} name='Allow' onChange={handleToggle} />
                                    <h4 className='mt-2'>Allow virtual Device?</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default VirtualDevice;


